import React, { ReactElement, FC, ReactNode } from 'react'
import { Typography } from 'antd'
import { s } from './style'

const { Text } = Typography

interface StepTitleProps {
  title: string
  timeCompleted?: string
  extra?: ReactNode
}

export const StepTitle: FC<StepTitleProps> = ({ title, timeCompleted, extra }): ReactElement => {
  if (extra) {
    return (
      <div style={s.root}>
        <div style={s.title}>
          <Text strong>{title}</Text>
          {timeCompleted && <Text style={s.timeCompleted}>{timeCompleted}</Text>}
        </div>
        {extra}
      </div>
    )
  } else {
    return (
      <div style={s.title}>
        <Text strong>{title}</Text>
        {timeCompleted && <Text style={s.timeCompleted}>{timeCompleted}</Text>}
      </div>
    )
  }
}
